import { useBoolean } from '@fluentui/react-hooks';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import jShield from '../../../assets/icons/json/avantages/assurance-red.json';
import jTruck from '../../../assets/icons/json/avantages/camion-red.json';
import jDrill from '../../../assets/icons/json/avantages/percer-red.json';
import { useDocuments, useDocumentsManager } from '../../../contexts/documentContext';
import Banner from '../../Banner';
import BannerSmall from '../../BannerSmall';
import Page from '../../Page';
import TableDocuments from '../Documents/TableDocuments';
import Viewer from '../Documents/Viewer';

const AvantagesEtServices = () => {

    const { documents } = useDocuments();
    const { getFileData, markAsRead } = useDocumentsManager();
    const { state } = useLocation();

    useEffect(() => {
        setType(undefined);
    }, [state]);

    const [openedDocument, setOpenedDocument] = useState({});
    const [isViewerOpen, { setTrue: showViewer, setFalse: hideViewer }] = useBoolean(false);
    const [type, setType] = useState(undefined);

    const activeDocuments = useMemo(() => {
        if (!type) return [];
        else {
            let result = documents;
            if (!!type) result = result.filter(document => document.type === type);
            return result;
        }
    }, [documents, type]);

    const activeTypes = useMemo(() => {
        if (!!type) return [type];
        else return [];
    }, [type]);

    const categories = useMemo(() => {
        const categories = [
            { json: jDrill, key: "lePlusByEiffage", label: "Le + by Eiffage" },
            { json: jShield, key: "monSyndic", label: "Mon Syndic" },
            { json: jTruck, key: "mesOffres", label: "Mes offres" }
        ];
        return categories.map(category => ({
            ...category,
            badgeLabel: documents.filter(document => document.type === category.key && !document.lu).length
        }));
    }, [documents]);

    const onDismissed = useCallback(() => {
        setOpenedDocument({});
    }, []);

    const onPreview = async (document) => {
        let { fileData } = document;
        if (!fileData) {
            fileData = await getFileData(document);
            markAsRead(document);
            document.fileData = fileData;
        }
        setOpenedDocument(document);
        showViewer();
    };

    return <Page title="Avantages & Services">

        {!!type // Afficher une petite bannière si l'utilisateur sélectionne un type de document
            ? <BannerSmall categories={categories} onChange={type => setType(type)} types={activeTypes} />
            : <Banner categories={categories} onChange={type => setType(type)} types={activeTypes} />
        }
        {(!!type) && <TableDocuments documents={activeDocuments} onPreview={onPreview} />}

        <Viewer
            document={openedDocument}
            isOpen={isViewerOpen}
            onDismiss={hideViewer}
            onDismissed={onDismissed}
        />

    </Page>;

};

export default AvantagesEtServices;